import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import InvoiceCreate from "../components/InvoiceCreate";
import * as projectActions from "./../../../../../actions/project.actions";
import * as invoiceActions from "../../../../../actions/invoice.actions";
import { Mixpanel } from "../../../../../actions/mixpanel.actions";

class InvoiceCreateContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.projectActions.getPitches();
  }

  getProjects(pitches) {
    let allowedProjects = [];

    // status: in-progress, completed, reviewed.
    let status = [9, 12, 13];

    _.forEach(pitches, pitch => {
      if (pitch.sow && status.includes(pitch.match.project.status_id)) {
        const option = {
          id: pitch.match.project.id,
          value: pitch.match.project.title
        };
        allowedProjects.push(option);
      }
    });

    return allowedProjects;
  }

  handleSubmit(data) {
    this.props.invoiceActions.createInvoice(data);
    Mixpanel.track("Member - Invoices - Creation");
  }

  render() {
    const projects = this.getProjects(this.props.pitches);

    return <InvoiceCreate projects={projects} onSubmit={this.handleSubmit} />;
  }
}

const mapStateToProps = state => {
  return {
    pitches: state.project.pitches
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    invoiceActions: bindActionCreators(invoiceActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceCreateContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/invoice/containers/InvoiceCreateContainer.js